@if (show) {
  @if (signed !== totaldFields || needStamp) {
    <span
      class="pt-1 text-xs font-bold"
      >
      @if (signed !== totaldFields) {
        {{ totaldFields - signed }} required field{{
        totaldFields - signed > 1 ? 's' : ''
        }}
        @if (needStamp) {
          |
        }
      }
      @if (needStamp) {
        1 stamp
      }
    </span>
  } @else {
    <div class="flex items-center gap-3">
      <img src="assets/icons/complete-green.svg" alt="Complete" />
      <span class="pt-1 text-xs font-bold">Page complete</span>
    </div>
  }
}

@if (doNotSign) {
  <span class="pt-1 text-xs font-bold">{{
    isENote ? 'Do not sign' : 'Wet ink sign'
  }}</span>
}

